export function getAvailableLanguages(data) {
  if (data.length === 0) {
    return;
  }

  const allLanguages = [];
  Object.entries(data).forEach(([, { acf }]) => {
    Object
      .entries(acf.reader_profile_description_languages)
      .forEach(([key, value]) => {
        if (value === true) {
          const split = key.split('_');
          allLanguages.push(split[split.length - 1]);
        }
      });
  });

  const uniqueLanguages = allLanguages.filter((item, pos, self) => self.indexOf(item) === pos);

  return uniqueLanguages;
}
